import {
    CategoryIconMapping,
    createCategoryIconsService,
} from '@src/federations/shared/categoryIcons/CategoryIconsService';
import { logger } from '@src/app/logger';
import { defaultFlagDefinitions } from './flagsDefinitions';

const localStorageKey = 'sports::categoryIconMappings';

const stored = localStorage.getItem(localStorageKey);

let flagMapByCategoryId: Record<string, string> = stored != null
    ? JSON.parse(stored)
    : getCategoryToIconMappings(defaultFlagDefinitions);

const defaultFlag = 'default';

export function getFlagByCategory(categoryId: number): string {
    const flag = flagMapByCategoryId[`${categoryId}`];
    return flag || defaultFlag;
}

export async function loadLatestCategoryIconMappings() {
    try {
        const cmsMappings = await createCategoryIconsService().getCategoryIconMappings();
        flagMapByCategoryId = getCategoryToIconMappings(cmsMappings);

        localStorage.setItem(localStorageKey, JSON.stringify(flagMapByCategoryId));
    } catch (error) {
        logger.warn(`Could not load flag definitions from CMS: ${error}`);
    }
}

function getCategoryToIconMappings(mappings: CategoryIconMapping[]): Record<string, string> {
    const lookup: Record<string, string> = {};

    for (const mapping of mappings) {
        for (const category of mapping.categoryIds) {
            lookup[category.toString()] = mapping.iconKey;
        }
    }

    return lookup;
}
